const trustedwholesale = {
    id: 'trustedwholesale',
    publicSiteName: 'Trusted Wholesale',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#cd0211',
            secondary: '#0d4d97',
            color1: '#df1b29',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/trustedwholesale/favicon.ico',
        logo: '/trustedwholesale/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default trustedwholesale